<template>
	<div class="hospital-doctor-info-table">
		<Commontable :tableData="tableData" :headerData="headerData" :hasChecked="false"></Commontable>
	</div>
</template>

<script>
	import Commontable from "@/components/common-table.vue";

	export default {
		components: {
			Commontable
		},
		props: {
			tableData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				headerData: [{
						prop: 'Year',
						label: '年度',
						columnwidth: 100
					},
					{
						prop: 'HospitalName',
						label: '医院',
						columnwidth: 200
					},
					{
						prop: 'TechnicalOffices',
						label: '科室',
						columnwidth: 120
					},
					{
						prop: 'Doctor',
						label: '术者',
						columnwidth: 120
					},
					{
						prop: 'DoctorTitle',
						label: '术者职称',
						columnwidth: 120
					},
					{
						prop: 'SurgeryCountPerYear',
						label: '手术量/年',
						columnwidth: 120
					},
					{
						prop: 'InHospitalStatusName',
						label: '入院状态',
						columnwidth: 120
					},
					{
						prop: 'LEVEL3',
						label: '重点产品（L3）',
						columnwidth: 150
					},
					{
						prop: 'SalesAmountPerMonth',
						label: '月均销量',
						columnwidth: 120
					},
					{
						prop: 'CreatorName',
						label: '创建人',
						columnwidth: 120
					},
					{
						prop: 'CreateTime',
						label: '生成日期',
						columnwidth: 150
					}
				]
			};
		}
	};
</script>

<style scoped>
	.hospital-doctor-info-table {
		width: 100%;
	}
</style>
